import { FC } from 'react'
import Image from 'next/image'

import { CallDropped, LocationMark, Mail } from '@/components/icons'
import { IRepresentationsData } from '@/types'

const RepresentativesCard: FC<IRepresentationsData> = ({
  full_name,
  avatar,
  address,
  phone,
  email,
}) => {
  return (
    <article className="grid min-h-[128px] grid-cols-1 gap-5 rounded-[12px] border border-secondary-light bg-white p-6 font-medium sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      <p className="flex flex-[1.1_1.1_0%] flex-row items-center gap-4 font-semibold text-secondary-darkest">
        <span className="h-[80px] w-[80px] overflow-hidden rounded-full border border-secondary-light">
          <Image
            src={avatar}
            width={80}
            height={80}
            alt={'avatar of ' + full_name}
            className="h-full w-full object-cover"
          />
        </span>
        {full_name}
      </p>
      <p className="flex flex-1 flex-row items-center gap-2 text-secondary-darkest">
        <span className="rounded-full border border-secondary-light p-3 text-primary">
          <LocationMark />
        </span>
        <span>{address}</span>
      </p>
      <a
        aria-label={full_name}
        href={`tel:${phone}`}
        className="flex flex-[0.7_0.7_0%] flex-row items-center gap-2"
      >
        <span className="rounded-full border border-secondary-light p-3 text-primary">
          <CallDropped />
        </span>
        <span>{phone}</span>
      </a>
      <a
        href={`mailto:${email}`}
        aria-label={full_name}
        className="flex flex-1 flex-row items-center gap-2"
      >
        <span className="rounded-full border border-secondary-light p-3 text-primary">
          <Mail />
        </span>
        <span>{email}</span>
      </a>
    </article>
  )
}

export default RepresentativesCard
